import e from "@dialpad/dialtone-tokens/layered/themes/tokens-104-colors.css?inline";
//#region themes/104.js
var t = { brand: {
	css: e,
	name: "104"
} };
//#endregion
export { t as default };
